/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useState, useCallback, useMemo} from 'react';
// redux
import {useSelector} from 'react-redux';
// material
import ExpandableSection from '../../../../../material/expandablesection/expandablesection';
import ConfigController from '../../../../../material/expandablesection/controllers/configcontroller/configcontroller';
import SectionCard from '../../../../../material/expandablesection/sectioncard/sectioncard';
import SectionGroup from '../../../../../material/expandablesection/sectiongroup/sectiongroup';
import {CopySnippetField, InlineMessage} from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './sentiment_styles';
import {PRODUCT_ARTICLE_SENTIMENT} from "../../../../../state/thunks/engagement";


/* ========== ~~~~~~~~~~ SENTIMENT CODE ~~~~~~~~~~ ========== */
const SentimentCode = injectSheet(styles)((props) => {
  const {
    engagement: {
      articleSentimentUnitCode,
      headerCode,
      accountProducts,
    },
  } = useSelector((state) => state);

  const [isOpened, setIsOpened] = useState(false);

  const hasArticleSentimentAccess = useMemo(() =>
      accountProducts.includes(PRODUCT_ARTICLE_SENTIMENT)
    , [accountProducts]
  )

  const handleToggle = useCallback(() => {
    setIsOpened(!isOpened)
  }, [isOpened]);

  const controller = (
    <ConfigController
      handleToggle={handleToggle}
      handleCancel={handleToggle}
      isOpened={isOpened}
      title='Article Sentiment'
      description={''}
      cancelTitle={'Close'}
    />
  );
  return (
    <ExpandableSection
      className={`${props.classes.sentimentcode} isDisabled-${hasArticleSentimentAccess ? 'false' : 'true' }`}
      controller={controller}
      isOpened={isOpened}
      handleCancel={handleToggle}
      cancelTitle={'Close'}
    >
      <SectionCard>
        <SectionGroup>
          <CopySnippetField
            title={'Header Code'}
            description={<div className='subtitle'>Place the article sentiment code right after the {`<head>`} tag in your HTML source code.</div>}
            codeSnippet={headerCode}
          />
          <div className={`codemessage`}>
            <InlineMessage
              key={'meow'}
              display={true}
              name={'headercode'}
              variant={'system'}
              icon={'exclamation-triangle'}
              title={null}
              message={
                <span>Insticator Header Code is the same for all ‘hard-coded’ insticator units – only add it to your site once.</span>}
              close={false}
              handleClose={null}/>
          </div>
          <CopySnippetField
            title={'Article Sentiment Code'}
            description={
              <div className='subtitle'>Place the Article Sentiment Unit code inside of the {`<body>`} tag in your HTML
                source code where you want the Article Sentiment Unit to appear in your site.
              </div>
            }
            codeSnippet={articleSentimentUnitCode}
          />
          <div className={`codemessage`}>
            <InlineMessage
              key={'meow'}
              display={true}
              name={'headercode'}
              variant={'system'}
              icon={'exclamation-triangle'}
              title={null}
              message={
                <span>Make sure you replace <strong>{`{articleURL}`}</strong> within the code you just copied with the actual URL of the specific page where Article Sentiment will live</span>}
              close={false}
              handleClose={null}/>
          </div>
        </SectionGroup>
      </SectionCard>
    </ExpandableSection>
  );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default SentimentCode;
